<!-- @veltra/icons generated sha256:68b112d42af5f61d gen:8 source:src/svg/normal/form-checkbox.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormCheckbox' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <rect
      width="12"
      height="12"
      x="2"
      y="2"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      rx="2"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.2"
      d="m5 8 2 2 4-4"
    />
  </svg>
</template>
